
import API from '@/api'

const actions = {
  getActualize({
    dispatch,
    commit,
    state,
    getters
  }) {
    commit('setActualizeStatus', 'pending')
    commit('incrementActualizeId')
    const callActualize = () => {
      API.cart.getActualize(getters.getActualizeIds)
        .then(({ data: { data } }) => {
          commit('setActualize', data)
        })
        .catch((response) => {
          const {
            status,
            data: {
              actualizeId,
              errors
            }
          } = response

          switch (status) {
            case 405:
              commit('setActualizeTourResearch', {
                actualizeId,
                errors: [{
                  title: 'Актуализация',
                  detail: 'Тур более не актуален, требуется перепоиск.'
                }]
              })
              break
            case 409:
              commit('setActualizeError', {
                actualizeId,
                errors
              })
              break
            case 422:
              commit('setActualizeValidateError', {
                actualizeId,
                errors
              })
              break
            default:
              commit('setActualizeFatalError', {
                actualizeId,
                errors: [{
                  title: 'Актуализация',
                  detail: 'критическая ошибка. Дальнейшая работа с корзиной невозможна.'
                }]
              })
              break
          }
        })
    }

    if (state.actualize.status === 'loadingAllowed'
      || state.actualize.status === 'pending') {
      callActualize()

      if (state.actualize.id < 12) {
        setTimeout(() => {
          if (state.actualize.status === 'loadingAllowed'
            || state.actualize.status === 'pending') {
            dispatch('getActualize')
          }
        }, (5 * 60 * 1000))
      }
    }
  },
}

export default actions